import { AppHelper } from 'helpers/appHelper';
import { useRecoilState } from 'recoil';
import { AcctState } from 'stores/atoms/acctState';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';

import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/navigation';
import { ContentHelper } from 'helpers/contentHelper';

/**
 *　ホーム画面 直近のコンテンツレポートコンポーネント
 */
export default function WsIndexContentsUnpublished(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [acctState] = useRecoilState(AcctState);

  const [contentSelectedState, setContentSelectedState] = useState(
    acctState.activeContent?.unpublished[0]
  );

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   *　スワイパー変更時の処理
   */
  const onSlideChange = (swiper: SwiperClass) => {
    setContentSelectedState(acctState.activeContent?.unpublished[swiper.activeIndex]);
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <div className="col-md-4">
        <div className="card card-simple" data-mh="card-simple">
          <div className="card-header">
            <h3 className="title-with-icon title-with-icon-sm mb-0">
              <img src="/img/icon/pen.svg" alt="作成中コンテンツ" className="icon-pen" />
              作成中コンテンツ
            </h3>
          </div>
          <div className="card-body">
            <div className="ws-index-quizzesswiper-container swiper-simple">
              <Swiper modules={[Navigation]} navigation onSlideChange={onSlideChange}>
                {acctState.activeContent?.unpublished.map(quiz => {
                  return (
                    <SwiperSlide key={`ws-index-quizzes-up-swiper-${quiz.id}`}>
                      <div
                        style={{ minHeight: '185px' }}
                        className="d-flex flex-column justify-content-end"
                      >
                        <img
                          src={AppHelper.getContentImageUrl(quiz.imageKey)}
                          className="img-fluid mx-auto d-block"
                          style={{ maxWidth: '185px' }}
                        />
                        <p className="caption text-center">{quiz.title}</p>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
            {/* 編集ボタン */}
            {contentSelectedState && (
              <div className="text-center">
                <NavLink
                  to={`/ws/${acctState.company.cd}/${ContentHelper.getContentsTypeStr(
                    contentSelectedState.contentsTypeDiv
                  )}/edit/${contentSelectedState?.cd}`}
                  className="btn btn-outline blue"
                >
                  編集する
                </NavLink>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}
